import {
    platformNewsDefinitions,
} from "../../../../content/platform-news";
import FsbSorm2026Article from "../articles/FsbSorm2026Article";
import PlatformNewsReleaseArticle from "../articles/PlatformNewsReleaseArticle";

const customArticleRenderers = Object.freeze({
    "fsb-sorm-2026": FsbSorm2026Article,
});

function resolveArticle(newsItem) {
    if (newsItem.articleType === "release") {
        return PlatformNewsReleaseArticle;
    }

    if (newsItem.articleType === "custom") {
        const Article = customArticleRenderers[newsItem.id];

        if (Article) {
            return Article;
        }
    }

    throw new Error(
        `Article renderer is not registered for news item: ${newsItem.id}`
    );
}

export const platformNewsItems = platformNewsDefinitions.map(
    (newsItem) => ({
        ...newsItem,
        Article: resolveArticle(newsItem),
    })
);
